
export const AppRoutes = {
    HOME: '/',
    CATALOG: '/catalog',
    MORTGAGE: '/mortgage',
    PROJECT: '/project/:id',
    POLICY: '/privacy-policy',
    NOTFOUND: '/not-found'
}